import { Field, Textarea } from '../../../libs/gs-component-form';
import { Content } from '../../../libs/gs-component-right-rail';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { Field as FormikField, Form as FormikForm } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { LivestreamItemsFragment, Maybe } from '../../../generated/graphql';
import { SharedFormProps } from '../../../helpers/useManageItem';
import { Footer } from '../../FormComponents';
import { DeleteOrDiscard } from '../DeleteOrDiscard';
import styles from '../EmbedItem/index.scss';
import { useAiTextExperimentContext } from '../../../context/AiTextExperimentContext';

export const validationSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  description: Yup.string().required('Description is required'),
  buttonText: Yup.string()
    .required('Button Text is required')
    .max(30, '30 characters maximum'),
  buttonUrl: Yup.string()
    .required('Livestream link is required')
    .url('Not a valid link')
    .matches(
      /(?:(zoom)\.us|(youtu\.be)|(twitch)\.tv|(ev(?:ent|t)\.live)|(?:(facebook)|(instagram)|(youtube)|meet\.(google))\.com)/,
      'Service is not supported'
    ),
});

export interface InitialValues {
  id?: number | null;
  title?: string | null;
  description?: string | null;
  buttonText?: string | null;
  buttonUrl?: string | null;
}

export const initialValues = (item?: Maybe<LivestreamItemsFragment>): InitialValues => ({
  title: item?.title || '',
  description: item?.description || '',
  buttonText: item?.buttonText || '',
  buttonUrl: item?.buttonUrl || '',
});

const Form: React.FC<SharedFormProps> = ({ submitForm, loading, updating, discardOrDelete, isNew, close }) => {
  const { showAiButton } = useAiTextExperimentContext();
  return (
    <>
      <Content className={styles.content} loading={loading}>
        <FormikForm>
          <FormBlockColumn>
            <FormikField name="title" label="Title" component={Field} data-testid="title" />
          </FormBlockColumn>
          <FormBlockColumn>
            <FormikField
              data-testid="description"
              name="description"
              placeholder="Add a short description"
              label={false}
              showAiButton={showAiButton}
              component={Textarea}
            />
          </FormBlockColumn>
          <FormBlockColumn>
            <FormikField name="buttonText" label="Button Text" component={Field} data-testid="button-text" />
          </FormBlockColumn>
          <FormBlockColumn>
            <FormikField name="buttonUrl" label="Button Url" component={Field} data-testid="button-url" />
          </FormBlockColumn>
          <DeleteOrDiscard onClick={discardOrDelete} isNew={isNew}>
            Delete item
          </DeleteOrDiscard>
        </FormikForm>
      </Content>
      <Footer primaryOnClick={submitForm} showSpinner={updating} useSaveAndPreview={true} secondaryOnClick={close} />
    </>
  );
};

export default Form;
